import { useState } from "react";

export function useLocalStorageState(localStorageName, defaultValue) {
  let initial;

  const storedJson = window.localStorage.getItem(localStorageName);
  try {
    initial = JSON.parse(storedJson) || defaultValue;
  } catch (error) {
    initial = storedJson;
  }

  const [get, set] = useState(initial);

  return [get, (value) => {
    try {
      window.localStorage.setItem(localStorageName, JSON.stringify(value))     
    } catch (error) {
      console.error(error)
    }
    set(value);
  }];
}